/* eslint-disable import/no-anonymous-default-export */
import { Button, Form, Input, Modal, notification, Progress, Table, Tooltip } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import axios from "axios";
import { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import DataFilter from "../common/components/DataFilter";
import DataTable from "../common/components/DataTable";
import EditableCell from "../common/components/EditableCell";
import MainLayout from "../common/components/MainLayout";
import AppStateContext from "../common/contexts/AppStateContext";
import ActaPreview, { ActaPreviewRef } from "../infracciones/components/ActaPreview";
import useLotesPrecargaAPI from "../lotes-precarga/useLotesPrecargaAPI";
import useConfiguracionesProduccionAPI, { ConfiguracionProduccion } from "./useConfiguracionesProduccionAPI";
import { message } from 'antd'; // o el componente de modal que uses
import { PoweroffOutlined } from "@ant-design/icons";

const ProgressContainer = styled.div`
margin-top: 1rem;
padding: 1rem;
background: white;
& > span
{
    font-size: 0.7rem;
    font-weight: 600;
}
`;

const StyledProgress = styled(Progress)`
width:100%;
`;

const StyledHint = styled.div`
font-size: 0.75rem;
font-weight: 600;
`;
const StyledContainer = styled.div`
margin-top:1rem;
& > div:first-child
{
    margin-bottom:0.75rem;
}
background: white;
padding: 1rem;
box-shadow: rgb(0 0 0 / 10%) 0px 1px 3px 0px, rgb(0 0 0 / 6%) 0px 1px 2px 0px;
border-radius: 5px;
margin-bottom: 1rem;
`;


export default () => {
    const appStateContext = useContext(AppStateContext);
    const api = useConfiguracionesProduccionAPI();
    const lotePrecargaApi = useLotesPrecargaAPI();
    const createPage = "/configuraciones-produccion/guardar"
    const editPage = "/configuraciones-produccion/guardar/{Id}"
    const [percent, setPercent] = useState(0);
    const [nombreFilterForm] = Form.useForm();
    const actaPreviewRef = useRef<ActaPreviewRef>(null!);
    const instances = appStateContext?.instances ?? {};
    const { confirm } = Modal;

    const generateFilters = (filters: Record<string, FilterValue | null>) => {
        return [
            filters?.Nombre != null ? `contains(Nombre,'${filters!.Nombre![0]}')` : "",

        ];
    }

    const previewActa = (configuracionProduccionId: number) => {
        actaPreviewRef.current.setConfiguracionProduccionId(configuracionProduccionId.toString());
        actaPreviewRef.current.setOpen(true);
    };

    useEffect(() => {
        const handleUnload = (event: BeforeUnloadEvent) => {
            event.preventDefault();
            event.returnValue = "";
        }

        window.addEventListener("beforeunload", handleUnload);

        return () => {
            window.removeEventListener("beforeunload", handleUnload);
        };
    }, []);

    const handleCancel = async (configProdNombre: string | undefined, urlCancel: string) => {
        if (urlCancel == '') {
            message.error('Error al cancelar la carga, URL de cancelación no disponible ');
            return;
        }

        confirm({
            title: '¿Cancelar carga?',
            content: `¿Estás seguro de que deseas cancelar la carga de "${configProdNombre}"?`,
            okText: 'Sí, cancelar',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                try {
                    const url = `${urlCancel}`;

                    const response = await fetch(url, {
                        method: 'POST', // o 'GET' según necesites
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                    if (response.ok) {
                        message.success('Carga cancelada exitosamente');
                        // Aquí puedes actualizar el estado local si es necesario
                    } else {
                        message.error('Error al cancelar la carga');
                    }
                } catch (error) {
                    message.error('Error de conexión al cancelar');
                    console.error('Error:', error);
                }
            },
        });
    }

    const preload = async (item: ConfiguracionProduccion) => {
        const confirmar = await new Promise<boolean>((resolve) => {
            Modal.confirm({
                title: 'Confirmar precarga',
                content: '¿Estás seguro de que deseas iniciar la precarga?',
                okText: 'Confirmar',
                cancelText: 'Cancelar',
                onOk: () => resolve(true),
                onCancel: () => {
                    notification.info({
                        message: 'Precarga cancelada',
                        placement: 'bottomRight'
                    });
                    resolve(false);
                }
            });
        });

        if (confirmar) {
            try {
                notification.info({
                    message: 'Precarga iniciada...',
                    placement: 'bottomRight'
                });

                const response = await lotePrecargaApi.preload(item.Id);

                if (response.error) {
                    if (axios.isAxiosError(response.error) && response.error.response?.data === 'EnProgreso') {
                        notification.error({
                            message: 'Precarga en progreso',
                            placement: 'bottomRight'
                        });
                        return;
                    }

                    notification.error({
                        message: 'Error al realizar la precarga',
                        placement: 'bottomRight'
                    });
                    return;
                }

                // Resto de tu lógica si la precarga es exitosa...

            } catch (error) {
                notification.error({
                    message: 'Error al realizar la precarga',
                    placement: 'bottomRight'
                });
            }
        }
    };

    return (
        <MainLayout >
            <ActaPreview ref={actaPreviewRef} />
            <DataTable<ConfiguracionProduccion, ConfiguracionProduccion>
                list={(query) => api.list({ ...query, ...{ $expand: ["UnidadProduccion"] } })}
                delete={api.delete}
                createAction={{
                    label: "Agregar configuración de producción",
                    path: createPage
                }}
                defaultSortOrder={"Id asc"}
                title={"Configuraciones de producción"}
                generateFilters={generateFilters}
                editItemAction={editPage}
                deleteItemAction
                deleteItemActionConfirmMessage={(item) => `¿Eliminar a ${item.Nombre}?`}
                defaultPageSize={25}
                itemActions={[

                    {
                        label: 'Previsualizar acta',
                        key: 'preview_acta',
                        action: (item) => previewActa(item.Id)
                    },
                    {
                        label: "Iniciar precarga",
                        key: "start_preload",
                        action: preload
                    }]}
            >

                <Table.Column<ConfiguracionProduccion>
                    width={`5%`}
                    title="ID"
                    dataIndex={"Id"}
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                />

                <Table.Column<ConfiguracionProduccion>
                    width={`45%`}
                    title="Nombre"
                    dataIndex={"Nombre"}
                    sorter
                    render={(val, record) =>
                        <EditableCell<Partial<ConfiguracionProduccion>>
                            save={(data) => api.save({ ...data, ...{ ConfiguracionesFecha: undefined } })}
                            id={record.Id}
                            render={(value) => value.Nombre!}
                            formValue={{ Nombre: val }}
                            formItem={<Form.Item style={{ marginBottom: 0 }} name={"Nombre"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={nombreFilterForm} >
                                <Form.Item name={"Nombre"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='Nombre...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                    }

                />

                <Table.Column<ConfiguracionProduccion>
                    width={`40%`}
                    title="Unidad de produccion"
                    dataIndex={"UnidadProduccion"}
                    //sorter
                    render={(val, record) => record.UnidadProduccion.Nombre}
                    defaultSortOrder={'descend'}
                //sortDirections={["ascend", "descend", "ascend"]}
                />
            </DataTable>

            {Object.keys(instances).map((key) => {
                const state = instances[key];
                var configProdNombre = state.PrecargaConfiguracionProduccionNombre ?? '-';
                return (
                    <ProgressContainer key={key}>
                        <div style={{ fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            Instancia de Precarga {key}
                            {state.CargandoInfracciones && (
                                <Tooltip title="Cancelar">
                                    <Button type="primary" danger shape="circle" icon={<PoweroffOutlined />} onClick={() => handleCancel(configProdNombre, state.UrlCancelarPrecarga!)} />
                                </Tooltip>
                            )}
                        </div>
                        <span>
                            Ultima carga: {state.UltimaCargaInfracciones?.format("DD/MM/YYYY HH:mm:ss") ?? "-"}
                            {state.CargandoInfracciones ? " (Procesando...)" + ` Configuración de producción: ${configProdNombre}` : ""}
                        </span>

                        <StyledProgress
                            percent={state.PorcentajeCargaInfracciones}
                            status={state.CargandoInfracciones ? "active" : "normal"}
                        />

                    </ProgressContainer>
                );
            })}
        </MainLayout>
    );

};